import { Observable } from "rxjs";

import { ArgumentNullError } from "@gp/utility";

import { IBetBoosterSubscriptionRequest, IBetBoosterSubscriptionResponse, IConnection } from "../../common";
import { Hub } from "../../Hub";
import { BetBoosterHubOptions } from "./BetBoosterHubOptions";

/**
 * BetBoosterHub is used for quick play and most played updates
 */
export class BetBoosterHub extends Hub {
	/**
	 * Creates an instance of BetBooster Hub
	 * @param options
	 * @param connection 
	 */
	constructor(options: BetBoosterHubOptions, connection: IConnection) {
		super(options, connection);
	}

	/**
	 * Get changes for event pressure index
	 * @param request subscription request filter
	 * @returns observable that is updated every time new message arrives on the hub
	 */
	getSubscription(request: IBetBoosterSubscriptionRequest): Observable<IBetBoosterSubscriptionResponse[]> {
		if (request == null) {
			throw new ArgumentNullError('request');
		}

		return this.createSubscription<IBetBoosterSubscriptionResponse[]>(request.subscriptionId, () => {
			return this.invoke('Subscribe', request);
		}, () => this.invoke('Unsubscribe', { subscriptionId: request.subscriptionId }));
	}
}